module.exports = __webpack_public_path__ + "040e1d056c3dcd9e3d5fe5ffc4f100f3.MP3";